// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"49f3278c","457":"6f4e5714","851":"9f7f5c8a"}[chunkId] + ".chunk.js";
};